document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('.menu-drawer');
  const search = document.querySelector('[data-search-panel]');
  const overlay = document.querySelector('[data-overlay]');
  const setOpen = (panel, open) => {
    panel?.classList.toggle('is-open', open);
    panel?.setAttribute('aria-hidden', String(!open));
    overlay?.classList.toggle('is-open', open);
    document.body.classList.toggle('no-scroll', open);
  };
  document.querySelector('.menu-button')?.addEventListener('click', () => setOpen(drawer, true));
  document.querySelector('[data-drawer-close]')?.addEventListener('click', () => setOpen(drawer, false));
  document.querySelector('[data-search-open]')?.addEventListener('click', () => setOpen(search, true));
  document.querySelector('[data-search-close]')?.addEventListener('click', () => setOpen(search, false));
  overlay?.addEventListener('click', () => { setOpen(drawer, false); setOpen(search, false); });
  const revealItems = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  const departmentNav = document.querySelector('[data-department-nav]');
  const colourwayCards = [...document.querySelectorAll('.colourway-card')];
  if (departmentNav && colourwayCards.length) {
    const departments = {
      heavyweights: ['good-times-heavyweight-t-shirt', 'good-times-track-pants', 'pe-signature-sweatshirt', 'pleasure-college-hoodie', 'athletic-club-hoodie', 'good-times-heavyweight-tee', 'pe-collegiate-sweatshirt'],
      'prep-sport': ['good-times-quarter-zip', 'pleasure-athletic-rugby-shirt', 'athletic-club-hoodie', 'pe-collegiate-sweatshirt'],
      workwear: ['pe-canvas-workwear-jacket', 'good-times-track-pants', 'pe-vintage-washed-cap', 'pe-organic-cord-cap'],
      'off-duty': ['good-times-heavyweight-t-shirt', 'good-times-track-pants', 'pe-signature-sweatshirt', 'pleasure-college-hoodie', 'good-times-quarter-zip', 'athletic-club-hoodie', 'good-times-club-tote', 'good-times-heavyweight-tee', 'pe-collegiate-sweatshirt', 'pe-organic-cord-cap'],
      caps: ['pe-vintage-washed-cap', 'pe-organic-cord-cap', 'good-times-club-tote']
    };
    const requested = new URLSearchParams(window.location.search).get('department') || 'all';
    const activeDepartment = requested === 'all' || departments[requested] ? requested : 'all';
    let visibleCount = 0;
    colourwayCards.forEach((card) => {
      const visible = activeDepartment === 'all' || departments[activeDepartment].includes(card.dataset.productHandle);
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });
    departmentNav.querySelectorAll('[data-department]').forEach((link) => {
      link.classList.toggle('is-active', link.dataset.department === activeDepartment);
      if (link.dataset.department === activeDepartment) link.setAttribute('aria-current', 'page');
    });
    const count = document.querySelector('[data-colourway-count]');
    if (count) count.textContent = String(visibleCount);
    const label = document.querySelector('[data-colourway-label]');
    if (label) label.textContent = activeDepartment === 'all' ? 'LIVE COLOURWAYS' : 'AVAILABLE IN THIS DEPARTMENT';
    const emptyState = document.querySelector('[data-collection-empty]');
    if (emptyState) emptyState.hidden = visibleCount > 0;
  }

  const liveClock = document.querySelector('[data-live-clock]');
  if (liveClock) {
    const updateClock = () => {
      const time = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date());
      liveClock.textContent = `LONDON ${time}`;
    };
    updateClock();
    window.setInterval(updateClock, 30000);
  }

  const showGalleryImage = (gallery, thumbnail) => {
    const image = gallery?.querySelector('[data-product-main-image]');
    if (!image || !thumbnail) return;
    image.removeAttribute('srcset');
    image.src = thumbnail.dataset.imageSrc;
    image.alt = thumbnail.dataset.imageAlt;
    const caption = gallery.querySelector('[data-gallery-caption]');
    if (caption) caption.textContent = thumbnail.dataset.imageAlt;
    gallery.querySelectorAll('[data-gallery-image]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button === thumbnail));
    });
  };
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    gallery.querySelectorAll('[data-gallery-image]').forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => showGalleryImage(gallery, thumbnail));
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantData = form.querySelector('[data-product-variants]');
    const variantInput = form.querySelector('[data-variant-id]');
    const selectors = [...form.querySelectorAll('[data-option-position]')];
    const submit = form.querySelector('.add-to-bag');
    const price = form.closest('.product-info')?.querySelector('.product-price');
    if (!variantData || !variantInput || !selectors.length || !submit) return;

    const variants = JSON.parse(variantData.textContent);
    const formatPrice = (value) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value / 100);
    const gallery = form.closest('.product-page')?.querySelector('[data-product-gallery]');
    const refresh = (event) => {
      selectors.forEach((select, index) => {
        [...select.options].forEach((option) => {
          option.disabled = !variants.some((variant) => variant.available
            && variant.options[index] === option.value
            && variant.options.slice(0, index).every((value, position) => value === selectors[position].value));
        });
        if (select.selectedOptions[0]?.disabled) {
          const firstAvailable = [...select.options].find((option) => !option.disabled);
          if (firstAvailable) select.value = firstAvailable.value;
        }
      });

      const selected = selectors.map((select) => select.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) {
        submit.disabled = true;
        submit.textContent = submit.dataset.unavailableLabel;
        return;
      }

      variantInput.value = variant.id;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? submit.dataset.addLabel : submit.dataset.unavailableLabel;
      if (price) price.textContent = formatPrice(variant.price);
      if (event && gallery && variant.featured_image) {
        const thumbnail = [...gallery.querySelectorAll('[data-gallery-image]')]
          .find((button) => button.dataset.galleryImage === String(variant.featured_image.id));
        showGalleryImage(gallery, thumbnail);
      }
      const url = new URL(window.location.href);
      if (event || url.searchParams.has('variant')) {
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    selectors.forEach((select) => select.addEventListener('change', refresh));
    refresh();
  });
});
